import React, { useState } from 'react'
import { Form } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import { responseError } from '../../helpers/responseHandler'
import { useChangePasswordMutation } from '../../redux/services/ProfileService'
import { convertToFormData, sweetAlert } from '../../utils'
import LoadingButtonWithForm from '../LoadingButtonWithForm'
import moment from "moment/moment";
import CustomPagination from "../CustomPagination";
import useLiveDataTable from "../../hooks/useLiveDataTable";
import {useGetAlertQuery} from "../../redux/services/AlertService";

const AlertList = ({ isEdit }) => {
    const {
        currentPage,
        perPage,
        q,
        searchQuery,
        setSearchQuery,
        handlePageChange,
        handlePerPageChange,
        handleSearchChange,
        onSearchKeyHandler
    } = useLiveDataTable();


    const { data: data2, isLoading, isFetching, refetch } = useGetAlertQuery(0)
    const alerts = data2?.response?.data?.data
    const total = data2?.response?.data?.total;

    const showStatusColor = (days) => {
        if (days == 0) {
            return 'bg-danger'
        } else if (days == 10) {
            return 'bg-warning'
        } else if (days == 20) {
            return 'bg-info'
        } else if (days == 30) {
            return 'bg-success'
        }
    }

    return (
        <>
            <div className="row">
                <div className="col-xl-12">
                    <div className="">
                        <div className="p-5">
                            <div className="mb-4 main-content-label">
                                Alerts
                            </div>

                            <CustomPagination
                                isFetching={isFetching}
                                data={alerts}
                                total={total}
                                onChangePage={handlePageChange} // Handle page change
                                onChangeRowsPerPage={handlePerPageChange} // Handle per page change
                                paginationDefaultPage={currentPage} // Set the current page

                                columns={[
                                    {
                                        name: 'Name',
                                        selector: row => row.name,
                                        sortable: true,
                                        width: '25%'
                                    },
                                    {
                                        name: 'Expiry Date',
                                        selector: row => (
                                            <>
                                                <span class={`badge ${showStatusColor(parseInt(row.minus_days))}`}>{row.expiry}</span>
                                            </>
                                        ),
                                        sortable: true,
                                    },
                                    {
                                        name: 'Message',
                                        selector: row => row.message,
                                        sortable: true,
                                        width: '30%'
                                    },
                                    {
                                        name: 'Minus Reminder Date',
                                        selector: row => (
                                            <>
                                                <span class={`badge ${showStatusColor(parseInt(row.minus_days))}`}>{row.minus_days} Days</span>
                                            </>
                                        ),
                                        sortable: true,
                                    },
                                    {
                                        name: 'Alert forward Date',
                                        selector: row => <>{moment(row.expiry).subtract(row.minus_days, 'days').format('YYYY-MM-D')}</>,
                                        sortable: true,
                                    },
                                    {
                                        name: 'Created At',
                                        selector: row => moment(row.created_at).format('YYYY-MM-DD'),
                                        sortable: true,
                                    },
                                    /*{
                                        name: 'Actions',
                                        cell: (row, i) => {
                                            return (
                                                <div className="hstack gap-1 fs-1">
                                                    {/!*<button
                                                        aria-label="view"

                                                        className="btn btn-icon btn-sm btn-primary-light btn-wave waves-effect waves-light"
                                                    >
                                                        <i className="ri-eye-fill" />
                                                    </button>*!/}
                                                    <button
                                                        aria-label="edit"
                                                        //

                                                        className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                                                    >
                                                        <i className="ri-edit-line" />
                                                    </button>
                                                    <a
                                                        aria-label="delete"

                                                        className="btn btn-icon btn-sm btn-danger-light btn-wave waves-effect waves-light"
                                                    >
                                                        <i className="ri-delete-bin-7-line" />
                                                    </a>
                                                </div>
                                            )
                                        },
                                        ignoreRowClick: true,
                                        allowOverflow: true,
                                        button: true,
                                        width: '220px'
                                    },*/
                                ]}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AlertList